import React, { Component } from 'react';
import { db, auth } from '../firebase';
import _ from 'lodash';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import axios from 'axios';

export default class Profile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: 'rohit.yadav',
            password: '',
            error: null,
            valid: false,
            working: false
        };
    }
    handleInputChange(field, value) {

        this.setState({
            [field]: value,success:false,error:null
        });
    };
    async syncData() {
        if (this.state.working) {
            return;
        }

        if (!this.state.username) {
            this.setState({ valid: false, error: "Please enter user name", working: false  ,success:false})
            return;
        }
        if (!this.state.password) {

            this.setState({ valid: false, error: "Please enter password", working: false ,success:false })
            return;
        }
        try {
            console.log(auth.uid());
            this.setState({ valid: false, working: true  ,success:false});
            let request_url = 'https://us-central1-stocksheet001.cloudfunctions.net/main/api/sync_rh?rh_user=' + encodeURIComponent(this.state.username) + '&rh_pass=' + encodeURIComponent(this.state.password) + '&uid=' + encodeURIComponent(auth.uid());
            //let request_url = 'https://us-central1-stocksheet001.cloudfunctions.net/main/api/sync_rh?rh_user=' + this.state.username + '&rh_pass=' + this.state.password + '&uid=' + auth.uid();
            // let request_url = '/main/api/sync_rh?rh_user=' + this.state.username + '&rh_pass=' + this.state.password + '&uid=' + auth.uid();
            let response = await axios.get(request_url);
            this.setState({ valid: false, working: false ,success:true});
        }
        catch (error) {

            this.setState({
                password: '',
                error: error.message,
                working: false,
                success:false
            });
        }
    }
    render() {

        return (
            <div className="ss-container-stacked ss-page">
                <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                    <div class="navbar-brand">
                        <a class="navbar-item" onClick={this.props.toggleDrawer}>
                            <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                        </a>
                    </div>
                    <div className="navbar-start">
                        <div className="navbar-item">
                            <div>
                                <p className="title is-4"><i className="fa fa-cog" style={{ marginRight: "0.75em" }}></i>Profile</p>
                            </div>
                        </div>
                    </div>
                </nav>
                <section class="section  ss-container-stacked ss-fluid-row" style={{ backgroundColor: "hsl(0, 0%, 96%)", alignItems: "center" }}>
                    <div className="card" style={{ paddingTop: 10, minWidth: "500px" }}>
                        <div class="card-content">
                            <div class='content'>
                                Enter your robinhood accout detials to sync your current positions with stocksheet.
                            </div>
                            <div className="notification is-info">
                                <i class="fa fa-info-circle" aria-hidden="true" style={{ marginRight: 10 }}></i>We do not save any credentials, they are discarded once the sync finishes.
                                    </div>
                            <form>
                                <div class="field">
                                    <label class="label">Email</label>
                                    <div class="control">
                                        <input class="input is-medium"
                                            type="text"
                                            placeholder="Your Username"
                                            autofocus=""
                                            value={this.state.username}
                                            onChange={(e) => this.handleInputChange("username", e.target.value)} />
                                    </div>
                                </div>

                                <div class="field">
                                    <label class="label">Password</label>
                                    <div class="control">
                                        <input class="input is-medium"
                                            type="password"
                                            placeholder="Your Password"
                                            value={this.state.password}
                                            onChange={(e) => this.handleInputChange("password", e.target.value)} />
                                    </div>
                                </div>
                                {this.state.success === true && <div className="notification is-success">
                                    <i class="fa fa-check-circle" aria-hidden="true" style={{ marginRight: 10 }}></i>Your positions has been synced.
                                    </div>}
                                {this.state.error && this.state.error.length > 0 && <div className="notification is-danger">
                                    <i class="fa fa-exclamation-circle" aria-hidden="true" style={{ marginRight: 10 }}></i> {this.state.error}
                                </div>}
                                <div class="field">
                                    <a class={"button is-block is-info is-medium" + (this.state.working ? " is-loading" : "")} onClick={() => this.syncData()}>
                                        <span class="icon is-medium">
                                            <i class="fa fa-refresh"></i>
                                        </span>
                                        <span>Sync RH</span>
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/containers/profile.js